import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Wrapper qui redirige automatiquement les utilisateurs non-Premium
 * (et non-admin) hors d'une page payante. Attend que AuthContext ait
 * fini son checkAuth() async pour éviter toute race condition au refresh.
 *
 * Usage :
 *   <PremiumRoute redirectTo="/respiration">
 *     <RespirationApaisantePage />
 *   </PremiumRoute>
 */
const PremiumRoute = ({ children, redirectTo = '/' }) => {
  const navigate = useNavigate();
  const { isPremium, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (!isPremium()) {
      navigate(redirectTo, { replace: true });
    }
  }, [loading, isPremium, navigate, redirectTo]);

  // Ne rien rendre tant que AuthContext n'a pas fini de charger,
  // ou si l'utilisateur n'est pas Premium (en attente de redirection).
  if (loading) return null;
  if (!isPremium()) return null;

  return children;
};

export default PremiumRoute;
